const apiConfig = {
  schnellrechner_pflege_vermoegen: {
    paths: {
      calc: '/anon/schnellrechner/calc/',
      pdf: '/anon/pdf/create/',
      taskData: '/anon/task/get_status/'
    }
  },
  vermoegensdepot_chance: {
    paths: {
      calc: '/anon/vermoegensdepo_chance/calc/',
      pdf: '/anon/pdf/create/',
      taskData: '/anon/task/get_status/'
    }
  },
  schnellrechner_risiko_leben: {
    paths: {
      calc: '/anon/risikoleben/beitrag/',
      pdf: '/anon/pdf/create/',
      taskData: '/anon/task/get_status/'
    }
  },
  jule_2018: {
    paths: {
      calc: '/anon/jule2018/calc/',
      email: '/anon/jule2018/send_mail/',
      bd_calc: '/anon/jule2018/bd/calc/',
      bd_finish: '/anon/jule2018/bd/finish/',
      get_jobs: '/anon/bu_risiko/calc/',
		}
  },
  generationendepot: {
    paths: {
      calc: '/anon/generationendepot/calc/',
      pdf: '/anon/pdf/create_new/',
      taskData: '/anon/task/get_status/'
    }
  },
  ruerup_rente: {
    paths: {
      config: '/anon/ruerup/config/v2/',
      foerderung: '/anon/ruerup/foerderung/v2/',
      pdf: '/anon/pdf/create_new/',
      taskData: '/anon/task/get_status/'
    },
    contact_url: {
      vkb: 'https://www.vkb.de/content/versicherungen/rente/gefoerderte-rente/ruerup-rente/beraten-anfragen/',
      slv: 'https://www.vkb.de/content/versicherungen/rente/gefoerderte-rente/ruerup-rente/beraten-anfragen/',
      fsoel: 'https://www.feuersozietaet.de/content/_resources/beratersuche/'
    }
  },
  riester_rente: {
    paths: {
      config: '/anon/riester/config/v2/',
      calc: '/anon/riester/calc/v2/',
      pdf: '/anon/pdf/create_new/',
      taskData: '/anon/task/get_status/'
    },
    contact_url: {
      vkb: 'https://www.vkb.de/content/versicherungen/rente/gefoerderte-rente/riester-rente/beraten-anfragen/',
      slv: 'https://www.vkb.de/content/versicherungen/rente/gefoerderte-rente/riester-rente/beraten-anfragen/',
      fsoel: 'https://www.feuersozietaet.de/content/versicherungen/rente/gefoerderte-rente/riester-rente/beraten-anfragen/?id=RIESTERRENTE'
    }
  },
  berufsunfaehigkeit: {
    paths: {
      calc: '/anon/bu_rechner/calc/',
      pdf: '/anon/pdf/create_new/',
      taskData: '/anon/task/get_status/'
    }
  },
  bu_risiko: {
    paths: {
      calc: '/anon/bu_risiko/calc/',
    }
  },
  index: {
    paths: {
      trend_years: '/anon/spv/index/query/trend/years/',
      trend_details: '/anon/spv/index/query/trend/details/',
      vip_euro_years: '/anon/spv/index/query/vip/years/',
      vip_euro_details: '/anon/spv/index/query/vip/details/'
    }
  },
  internship: {
    paths: {
      info: '/anon/intership/info/',
      calc: '/anon/intership/calc/',
      save_first: '/anon/intership/save_first/',
      confirm_download: '/anon/intership/confirm_download/',
      download_insurance: '/anon/intership/download_insurance/',
    }
  },
  risiko_check: {
    paths: {
      address: '/anon/risikocheck/address/',
      gk: '/anon/risikocheck/gk/',
      pdf: '/anon/risikocheck/pdf/',
    }
  },
  bedarfscheck_wohnen: {
    paths: {
      calc: '/anon/bedarfscheck_haus_wohnen/calc/'
    }
  },
  bedarfscheck_leben: {
    paths: {
      calc: '/anon/bedarfscheck_leben/calc/'
    }
  },
  sponsoring: {
    paths: {
      send_email: '/anon/sponsoring/'
    }
  },
  pflegebedarfs_check: {
    paths: {
      supervisor: '/anon/pflegebedarfs_check/supervisor/',
      filter_recommendation: '/anon/pflegebedarfs_check/filter_recommendation/',
      add_request: '/anon/pflegebedarfs_check/add_request/',
      filter_by_token: '/anon/pflegebedarfs_check/filter_by_token/',
      finish_request: '/anon/pflegebedarfs_check/finish_request/',
    }
  },
  index_app: {
    paths: {
      query: '/anon/index_app/query/'
    }
  },
  info: {
    paths: {
      infodata: '/anon/info/',
    }
  }
};

export default apiConfig;



// WEBPACK FOOTER //
// ./src/api/config.js